//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import {
  hasClienteComPA,
  isAdmin,
  isSudo,
} from '../../helpers/permissions.helper';
import FormInput from './../../components/Inputs/FormInput';
import SelectInput from './../../components/Inputs/SelectInput';
import { objectsConstants } from './../../constants/objects.constants';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { clienteService } from '../../services/cliente.service';
import DatePickerInput from '../../components/Inputs/DatePickerInput';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { userService } from '../../services/user.service';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class PedidosCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    const user = userService.getCurrentUser();
    console.log(user.cliente);

    return (
      <React.Fragment>
        {isSudo() && (
          <FormGroup className="col-12 col-md-3">
            <FormSelectInput
              name="cliente"
              id="cliente"
              label="Cliente"
              placeholder="Selecione o cliente"
              valueKey="codigoCliente"
              labelKey="label"
              required={true}
              returnFullObject={true}
              service={clienteService.findAll}
              onChange={this.props.onChangeDate}
              value={entity.cliente}
            />
          </FormGroup>
        )}
        {hasClienteComPA() && (
          <>
            <FormGroup className="col-12 col-md-2">
              <SelectInput
                name="statusInterno"
                id="statusInterno"
                label="Status"
                placeholder="Selecione"
                valueKey="value"
                labelKey="label"
                returnFullObject={false}
                options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
                onChange={(name, value) => {
                  this.props.onChangeValue(value, name);
                }}
                value={entity.statusInterno}
              />
            </FormGroup>
          </>
        )}
        <FormGroup className="col-12 col-xl-1">
          <FormInput
            label="Nº. pedido"
            placeholder={'Nº. pedido'}
            id={'numeroPedido'}
            name="numeroPedido"
            noSize
            onChange={this.props.onChangeDate}
            type={'text'}
            value={entity.numeroPedido}
          />
        </FormGroup>
        {hasClienteComPA() && (
          <>
            <FormGroup className="col-12 col-md-1">
              <FormInput
                label="Nº. pedido temporário"
                placeholder={'Nº. pedido temporário'}
                id={'numeroPedidoTemporario'}
                name="numeroPedidoTemporario"
                noSize
                onChange={this.props.onChangeDate}
                type={'text'}
                value={entity.numeroPedidoTemporario}
              />
            </FormGroup>
            <FormGroup className="col-12 col-xl-1">
              <FormInput
                label="Nº nota fiscal"
                placeholder={'Número da nota fiscal'}
                id={'numeroNotaFiscal'}
                name="numeroNotaFiscal"
                onChange={this.props.onChangeDate}
                type={'text'}
                value={entity.numeroNotaFiscal}
                noSize
              />
            </FormGroup>
          </>
        )}
        <FormGroup className="col-12 col-xl-2">
          <DatePickerInput
            name="createdAt"
            id={'createdAt'}
            label="Data criação"
            placeholder="Data criação"
            onChange={this.props.onChangeDate}
            value={entity.createdAt}
            noSize
          />
        </FormGroup>
        {isAdmin() && hasClienteComPA() && (
          <FormGroup className="col-12 col-xl-3">
            <FormSelectInput
              name="pontoAtendimentoId"
              id="pontoAtendimentoId"
              label="Ponto de Atendimento"
              placeholder="Selecione o PA"
              valueKey="id"
              labelKey="nome"
              required={true}
              returnFullObject={false}
              parent={isSudo() ? entity.cliente : user.cliente}
              service={
                isSudo()
                  ? pontoAtendimentoService.findAll
                  : pontoAtendimentoService.findAllByCliente
              }
              onChange={this.props.onChangeDate}
              value={entity.pontoAtendimentoId}
            />
          </FormGroup>
        )}

        {hasClienteComPA() && (
          <FormGroup className="col-12 col-xl-2">
            <SelectInput
              name="tipoPedido"
              id="tipoPedido"
              label="Tipo do pedido"
              placeholder="Selecione"
              valueKey="value"
              labelKey="label"
              returnFullObject={false}
              options={objectsConstants.TIPO_PEDIDO_FULL}
              onChange={(name, selected) => {
                this.props.onChangeValue(selected, name);
              }}
              value={entity.tipoPedido}
            />
          </FormGroup>
        )}
        {isAdmin() && hasClienteComPA() && (
          <>
            <FormGroup className="col-12 col-xl-3">
              <FormInput
                label="Criado por"
                placeholder={'Criado por'}
                id={'criadoPor'}
                name="criadoPor"
                onChange={this.props.onChangeDate}
                type={'text'}
                value={entity.criadoPor}
                noSize
              />
            </FormGroup>

            <FormGroup className="col-12 col-xl-3">
              <FormInput
                label="Aprovado/Recusado por"
                placeholder={'Aprovado/Recusado por'}
                id={'aprovadoPor'}
                name="aprovadoPor"
                onChange={this.props.onChangeDate}
                type={'text'}
                value={entity.aprovadoPor}
                noSize
              />
            </FormGroup>
            <FormGroup className="col-12 col-xl-3">
              <FormInput
                label="Paciente"
                placeholder={'Nome do paciente'}
                id={'nomePaciente'}
                name="nomePaciente"
                onChange={this.props.onChangeDate}
                type={'text'}
                value={entity.nomePaciente}
                noSize
              />
            </FormGroup>
          </>
        )}

        {isAdmin() && !hasClienteComPA() && (
          <FormGroup className="col-12 col-xl-3">
            <FormInput
              label="Nº pedido cliente"
              placeholder={'Número pedido cliente'}
              id={'numeroPedidoCliente'}
              name="numeroPedidoCliente"
              onChange={this.props.onChangeDate}
              type={'text'}
              value={entity.numeroPedidoCliente}
            />
          </FormGroup>
        )}
        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            name="statusAlcis"
            id={'statusAlcis'}
            label="Status WMS"
            placeholder="Selecione o status"
            options={objectsConstants.STATUS_PEDIDO_ALCIS}
            onChange={(name, value) => {
              console.log(value);

              this.props.onChangeValue(value, name);
            }}
            labelKey="label"
            valueKey="value"
            multi={false}
            returnFullObject={false}
            creatable={false}
            required={false}
            value={entity.statusAlcis}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-1">
          <SelectInput
            name="urgente"
            id="urgente"
            label="É Urgente?"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={true}
            options={objectsConstants.SIM_NAO}
            onChange={(name, selected) => {
              this.props.onChangeValue(selected.value, name);
            }}
            value={
              objectsConstants.SIM_NAO.find(
                (opt) => opt.value === entity.urgente
              ) || null
            }
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
